import React, { memo, forwardRef } from 'react';
import { useTheme, createUseStyles, Icon, Text } from '@Sage/hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'ToFieldFormatter');
const ToFieldFormatter = (_ref, ref) => {
  let {
    value
  } = _ref;
  const classes = useStyles();
  const theme = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classes.toField
  }, /*#__PURE__*/React.createElement(Text, {
    className: classes.toFieldName
  }, value), /*#__PURE__*/React.createElement(Icon, {
    name: "arrowRight",
    color: theme.colors.grey[200]
  }));
};
export default /*#__PURE__*/memo(/*#__PURE__*/forwardRef(ToFieldFormatter));